/* 🤖 this file was generated by svg-to-ts */
export const matIconNetworkWifi2Bar: {
  name: 'network-wifi-2-bar';
  data: string;
} = {
  name: 'network-wifi-2-bar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0 0 12 4zm4.78 9.38A8.853 8.853 0 0 0 12 12c-1.76 0-3.4.5-4.78 1.38l-4.3-4.3C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-4.3 4.31z"/></svg>`
};
